var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"lg10":"","sm12":"","xs12":""}},[_c('pedido-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }